import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { logoutUser } from "store/actions";
import FullPageLoader from "App/common/ui/FullPageLoader";

function LogoutIbackup(props) {
  useEffect(() => {
    props.logoutUser(true, "ibackup");
  }, []);
  return <FullPageLoader />;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logoutUser
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(LogoutIbackup);
